import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCsrf from 'vue-csrf'
import jquery from 'jquery'
import vSelect from 'vue-select'
import _ from 'lodash'
import VueSession from 'vue-session'
import loading from 'vuejs-loading-screen'
import Multiselect from 'vue-multiselect'
import VueHtmlToPaper from 'vue-html-to-paper'

import 'datatables.net-bs4'
// import buttons and plugins
import 'datatables.net-buttons/js/dataTables.buttons.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
// import the rest
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { numberFormat } from '././assets/js/number-format'
import JsonCSV from 'vue-json-csv'
import swal from 'sweetalert'
import 'babel-polyfill'
import moment from 'moment'
const options = {
  name: 'مركز ايديا للتعليم',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: 'مركز ايديا للتدريب' // override the window title
}
Vue.use(VueHtmlToPaper, options)
Vue.config.performance = true
Vue.use(CoreuiVue, VueAxios, axios, VueCsrf, jquery, VueSession, loading, Multiselect)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$http = axios
Vue.use(loading)
Vue.prototype.$ = jquery
Vue.prototype._ = _
Vue.prototype.$session = VueSession
Vue.component('v-select', vSelect)
Vue.component('multiselect', Multiselect)
Vue.component('modal', {
  template: '#modal-template'
})
Vue.component('downloadCsv', JsonCSV)

Vue.prototype.$hostUrl = process.env.VUE_APP_BACKEND_SERVER

axios.interceptors.request.use(req => {
  jquery('.loading').show()
  req.headers.authorization = 'Bearer ' + localStorage.token
  return req
})
axios.interceptors.response.use(function (response) {
  jquery('.loading').hide()
  return response
}, function (error) {
  jquery('.loading').hide()
  console.log(error)
  if (error.response.status === 401) {
    swal({
      title: 'انتهت الجلسة',
      text: 'انتهت صلاحية جلسة العمل الخاصة بك. هل ترغب في إعادة توجيهك إلى صفحة تسجيل الدخول؟',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      closeOnConfirm: false
    }).then((oKBtn) => {
      router.push({ path: '/login' })
    })
  } else {
    return Promise.reject(error)
  }
})
const vm = new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  data: {
    categories: 0,
    subCategories: 0
  }
})
vm.$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.authGuard) && !localStorage.token) {
    next({ name: 'Login' })
  }
  next()
})

Vue.filter('number', function (value) {
  return numberFormat(value, 0)
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD hh:mm')
  }
})
Vue.mixin({
  methods: {
    async postRequest (formData, url, create, uploadPercentage) {
      let errors = []
      await this.$http.post(`${url}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }.bind(this)
      })
        .then((response) => {
          if (!response.data.error) {
            swal({ title: response.data.message, buttons: 'تم' })
            if (create) {
              this.$router.push({ path: create })
            }
          } else {
            errors = response.data.data
          }
        }).catch(function (error) {
          if (Object.prototype.hasOwnProperty.call(error, 'response')) {
            const data = (error.response || {}).data
            if (data.error) {
              errors = data.data
              swal({
                title: data.message,
                buttons: 'تم'
              })
            } else {
              swal({
                title: 'حدث خطـأ اثناء معالجة الطلب الرجاء المحاولة لاحقا',
                buttons: 'تم'
              })
            }
          } else {
            swal({
              title: 'حدث خطـأ اثناء معالجة الطلب الرجاء المحاولة لاحقا',
              buttons: 'تم'
            })
          }
        })
      return errors
    }
  }
})
